export const sumCultivarsProperties = (items = [], filter = (val) => val) => {
  let array = items
  if (filter) {
    array = items.filter(filter)
  }
  return array.reduce((acc, item) => acc + Number(item.area), 0)
}
